import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { isAgreementSettingsEmpty, isPaymentSettingsEmpty } from '../../settings-predicates';
const dayBound = (range)=>{
    var _ref, _ref1, _ref2, _ref3, _ref4, _range_gt;
    var _range_in;
    return (_ref = (_ref1 = (_ref2 = (_ref3 = (_ref4 = (_range_gt = range.gt) !== null && _range_gt !== void 0 ? _range_gt : range.gte) !== null && _ref4 !== void 0 ? _ref4 : range.lte) !== null && _ref3 !== void 0 ? _ref3 : range.lt) !== null && _ref2 !== void 0 ? _ref2 : range.eq) !== null && _ref1 !== void 0 ? _ref1 : (_range_in = range.in) === null || _range_in === void 0 ? void 0 : _range_in[0]) !== null && _ref !== void 0 ? _ref : null;
};
const expirationIsNever = (predicate)=>{
    var _ref;
    var _predicate_type;
    return ((_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : []).includes('none');
};
const expirationValueLabel = (predicate, t)=>{
    var _ref;
    var _predicate_type;
    const types = (_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : [];
    if (types.includes('none')) return t.settingsExpirationNeverLabel();
    if (predicate.days != null) {
        const days = dayBound(predicate.days);
        if (days != null && (predicate.days.lte != null || predicate.days.lt != null)) {
            return t.settingsExpirationWithin({
                days
            });
        }
        if (days != null && (predicate.days.gt != null || predicate.days.gte != null)) {
            return t.settingsExpirationAfter({
                days
            });
        }
        if (days != null) return t.settingsExpirationIn({
            days
        });
    }
    if (types.includes('days')) return t.settingsExpirationSet();
    return t.settingsValueSet();
};
const approvalValueLabel = (predicate, t)=>{
    var _ref;
    var _predicate_type, _predicate_auto;
    const types = (_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : [];
    if (types.includes('manual')) return t.settingsApprovalManual();
    const autoDays = ((_predicate_auto = predicate.auto) === null || _predicate_auto === void 0 ? void 0 : _predicate_auto.days) != null ? dayBound(predicate.auto.days) : null;
    if (autoDays != null) return t.settingsApprovalAutoAfter({
        days: autoDays
    });
    if (types.includes('auto') || predicate.auto != null) return t.settingsApprovalAuto();
    return t.settingsValueSet();
};
const amendmentsApprovalValueLabel = (predicate, t)=>{
    var _ref;
    var _predicate_type, _predicate_auto;
    const types = (_ref = (_predicate_type = predicate.type) === null || _predicate_type === void 0 ? void 0 : _predicate_type.in) !== null && _ref !== void 0 ? _ref : [];
    if (types.includes('manual')) return t.settingsApprovalApprovedManual();
    const autoDays = ((_predicate_auto = predicate.auto) === null || _predicate_auto === void 0 ? void 0 : _predicate_auto.days) != null ? dayBound(predicate.auto.days) : null;
    if (autoDays != null) return t.settingsApprovalApprovedAutoAfter({
        days: autoDays
    });
    if (types.includes('auto') || predicate.auto != null) return t.settingsApprovalApprovedAuto();
    return t.settingsValueSet();
};
const ccFeesValue = (predicate, t)=>{
    var _ref, _predicate_in;
    const values = (_ref = (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : predicate.nin) !== null && _ref !== void 0 ? _ref : [];
    return values.map((value)=>value === 'client' ? t.settingsCcFeesPaidByClient() : t.settingsCcFeesPaidByServiceProvider()).join(', ');
};
export const paymentDescriptors = (settings, onChange, t)=>{
    const removeField = (field)=>{
        const { [field]: _omitted } = settings, next = _object_without_properties(settings, [
            _to_property_key(field)
        ]);
        onChange(isPaymentSettingsEmpty(next) ? undefined : next);
    };
    const descriptors = [];
    if (settings.requirePaymentMethod != null) {
        descriptors.push({
            field: 'requirePaymentMethod',
            fieldLabel: t.settingsPaymentMethodLabel(),
            valueLabel: settings.requirePaymentMethod ? t.settingsPaymentMethodRequired() : t.settingsPaymentMethodNotRequired(),
            onRemove: ()=>removeField('requirePaymentMethod')
        });
    }
    if (settings.creditCardFeesPaidBy != null) {
        const valueLabel = ccFeesValue(settings.creditCardFeesPaidBy, t);
        if (valueLabel.length > 0) {
            descriptors.push({
                field: 'creditCardFeesPaidBy',
                fieldLabel: t.settingsCcFeesLabel(),
                valueLabel,
                onRemove: ()=>removeField('creditCardFeesPaidBy')
            });
        }
    }
    return descriptors;
};
export const agreementDescriptors = (settings, onChange, t)=>{
    const removeField = (field)=>{
        const { [field]: _omitted } = settings, next = _object_without_properties(settings, [
            _to_property_key(field)
        ]);
        onChange(isAgreementSettingsEmpty(next) ? undefined : next);
    };
    const descriptors = [];
    if (settings.expirationDate != null) {
        descriptors.push({
            field: 'expirationDate',
            fieldLabel: expirationIsNever(settings.expirationDate) ? '' : t.settingsExpirationDateLabel(),
            valueLabel: expirationValueLabel(settings.expirationDate, t),
            onRemove: ()=>removeField('expirationDate')
        });
    }
    if (settings.amendmentsApprovalMethod != null) {
        descriptors.push({
            field: 'amendmentsApprovalMethod',
            fieldLabel: t.settingsAmendmentsFieldLabel(),
            valueLabel: amendmentsApprovalValueLabel(settings.amendmentsApprovalMethod, t),
            onRemove: ()=>removeField('amendmentsApprovalMethod')
        });
    }
    if (settings.outOfScopeChargesApprovalMethod != null) {
        descriptors.push({
            field: 'outOfScopeChargesApprovalMethod',
            fieldLabel: t.settingsOosApprovalLabel(),
            valueLabel: approvalValueLabel(settings.outOfScopeChargesApprovalMethod, t),
            onRemove: ()=>removeField('outOfScopeChargesApprovalMethod')
        });
    }
    if (settings.termsOfService != null) {
        var _settings_termsOfService_name;
        const termsName = (_settings_termsOfService_name = settings.termsOfService.name) === null || _settings_termsOfService_name === void 0 ? void 0 : _settings_termsOfService_name.contains;
        descriptors.push({
            field: 'termsOfService',
            fieldLabel: termsName != null ? t.settingsTermsOfServiceLabel() : '',
            valueLabel: termsName != null ? t.settingsTermsOfServiceContains({
                value: termsName
            }) : t.settingsTermsOfServiceExists(),
            onRemove: ()=>removeField('termsOfService')
        });
    }
    return descriptors;
};
